import { observer } from 'mobx-react-lite'
import useStore from 'reusable/mobx-store-utils/useStore'
import IconButton from '@mui/material/IconButton'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { useFormHandlerStore } from 'reusable/mobx-store-utils/form-handlers/new/FormHandlerStore'
import validatePassword from 'auth/validate/validatePassword'
import InputAdornment from '@mui/material/InputAdornment'

export type TextFieldPasswordProps = Pick<TextFieldProps, 'variant' | 'label' | 'fullWidth' | 'name' | 'autoComplete' | 'autoFocus'> & { skipValidation?: boolean }

export default observer(function TextFieldPassword(props: TextFieldPasswordProps) {
   const formHandlerStore = useFormHandlerStore()

   const { skipValidation, ...otherProps } = props

   const textFieldPasswordStore = useStore(() => ({
      showPassword: false,
      get icon() {
         return textFieldPasswordStore.showPassword ? Visibility : VisibilityOff
      },
      handleClickShowPassword: () => (textFieldPasswordStore.showPassword = !textFieldPasswordStore.showPassword),
      validatePassword: () => validatePassword(formHandlerStore)
   }))

   return (
      <TextField
         {...otherProps}
         type={textFieldPasswordStore.showPassword ? 'text' : 'password'}
         autoComplete={props.autoComplete}
         onBlur={skipValidation ? undefined : textFieldPasswordStore.validatePassword}
         InputProps={{
            endAdornment: (
               <InputAdornment position="end">
                  <IconButton
                     aria-label="toggle password visibility"
                     onClick={textFieldPasswordStore.handleClickShowPassword}>
                     <textFieldPasswordStore.icon />
                  </IconButton>
               </InputAdornment>
            ),
         }}
      />
   )
})
